// extracted by mini-css-extract-plugin
export default {"root":"html-select_root__AwJ8h","placeHolderShimmer":"html-select_placeHolderShimmer__A7MSH"};